import React from "react";
import H1 from "../../../atoms/Header";
import YU_COLOURS from "../../../../styles/colours";
import { fonts } from "../../../../fonts/index";
export var ModalTitle = function (_a) {
    var _b = _a.color, color = _b === void 0 ? YU_COLOURS.S3100 : _b, _c = _a.fontFamily, fontFamily = _c === void 0 ? fonts.heading : _c, _d = _a.fontWeight, fontWeight = _d === void 0 ? "normal" : _d, _e = _a.align, align = _e === void 0 ? "center" : _e, _f = _a.fontSize, fontSize = _f === void 0 ? "2.5rem" : _f, children = _a.children;
    return (React.createElement(H1, { color: color, fontFamily: fontFamily, fontWeight: fontWeight, align: align, fontSize: fontSize, pt: "1.5rem" }, children));
};
